import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdAdd, MdOutlineEdit, MdOutlineMeetingRoom } from "react-icons/md";
import { FaBed, FaCircle, FaEdit, FaInfoCircle, FaRupeeSign } from "react-icons/fa";
import { BsDash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Model from "../Model";
import { TbRectangleVerticalFilled } from "react-icons/tb";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { capitalizeFirstLetter, truncateText } from "../../helpers";
import moment from "moment";
import { FaFemale, FaMale } from "react-icons/fa";
import { BiMaleFemale } from "react-icons/bi";

const CustomTooltip = ({ children, content, id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState("bottom");

  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  const OFFSET = 8;

  const showTooltip = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    setCoords({
      x: rect.left + rect.width / 2,
      y: rect.bottom,
      topY: rect.top,
    });

    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };


  useLayoutEffect(() => {
    if (isVisible && tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - coords.y;

      if (spaceBelow < tooltipHeight + OFFSET) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    }
  }, [isVisible, coords]);

  return (
    <div className="relative inline-block">
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
      >
        {children}
      </div>

      {isVisible && (
        <div
          ref={tooltipRef}
          id={id}
          className="fixed z-50 bg-white text-gray-800
          px-4 py-3 text-sm
          shadow-xl rounded-lg
          border border-gray-200 max-w-xs"
          style={{
            left: coords.x,
            top:
              position === "bottom"
                ? coords.y + OFFSET
                : coords.topY - OFFSET,
            transform:
              position === "bottom"
                ? "translateX(-50%)"
                : "translate(-50%, -100%)",
          }}
        >
          {/* Arrow */}
          <div
            className="absolute w-3 h-3 bg-white"
            style={{
              left: "50%",
              transform:
                position === "bottom"
                  ? "translateX(-50%) rotate(45deg)"
                  : "translateX(-50%) rotate(225deg)",
              top: position === "bottom" ? "-6px" : "auto",
              bottom: position === "top" ? "-6px" : "auto",
              border:
                position === "bottom"
                  ? "1px solid #e5e7eb"
                  : "1px solid #e5e7eb",
            }}
          />

          {content}
        </div>
      )}
    </div>
  );
};


const Table = ({
  apiData,
  setAddBed,
  setSelectedData,
  setAddTenant,
  setAddMultipleTenant,
  setEditModel,
  isFlat,
  setFlatModel,
  setRoomNumberModel,
  propStatus,
  selectedFilter,
  selectedFloor,
  setIsExtraBed,
  setIsExtraBedDelete,
  handleOpenTenantModal,
  holdUnholdBedMutate,
  holdUnholdBedLoading,
  setIsBedActionModalOpen,
  isBedActionModalOpen,
  onHoldBedCountChange,
  setIsBedHistory
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedBed, setSelectedBed] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  //const [isBedActionModalOpen, setIsBedActionModalOpen] = useState(false);

  const openTenantDetailsModal = (tenantId) => {
    handleOpenTenantModal(tenantId);
  };

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [apiData]);

  const bed = (item) => {
    setAddBed(true);
    setSelectedData(item);
  };

  const handleDeleteBed = (bed) => {
    setIsExtraBedDelete(true);
    setSelectedData(bed);
  };
  const handleBedHistory = (bed) => {
    setIsBedHistory(true);
    setSelectedData(bed);
  };
  const editRoom = (item) => {
    setEditModel(true);
    setSelectedData(item);
  };

  const addRoomNumber = (item) => {
    setRoomNumberModel(true);
    setSelectedData(item);
  };

  const editFlat = (item) => {
    setFlatModel(true);
    setSelectedData(item);
  };

  // const tenant = (bed, item) => {
  //   setAddTenant(true);
  //   setSelectedData({ bed, item });
  // };
  const tenant = (bed, item) => {
    setSelectedData({ bed, item });

    if (bed.status === Config.BED_STATUS.RESERVED || bed.status === Config.BED_STATUS.VACANT_RESERVED) {
      setAddMultipleTenant(true);
      return;
    }

    setAddTenant(true);
  };


  const handleBedClick = (bed, item) => {
    if (bed.status === Config.BED_STATUS.MOVING_OUT) {
      setSelectedBed({ ...bed, item });
      setIsModalOpen(true);
    } else if (bed.status === Config.BED_STATUS.RESERVED ||
      bed.status === Config.BED_STATUS.VACANT_RESERVED
    ) {
      setSelectedBed({ ...bed, item });
      setIsModalOpen(true);
    } else if (
      bed.status === Config.BED_STATUS.OCCUPIED
      // ||
      // bed.status === Config.BED_STATUS.VACANT_RESERVED
    ) {
      // navigate(`/tenantdetails/b/${bed.occupancies[0]?.tenantId}`, {
      //   state: { tenantStatus: Config.TENANT_STATUS.OCCUPIED },
      // });
      openTenantDetailsModal(bed.occupancies[0]?.tenantId);
    } else if (bed.status === Config.BED_STATUS.VACANT && propStatus === 3) {
      tenant(bed, item);
    }
  };

  const handleBedDoubleClick = (bed, item) => {
    setSelectedBed({ ...bed, item });
    setIsBedActionModalOpen(true);
  };

  const handleAddNewTenant = () => {
    setIsModalOpen(false);
    //tenant(selectedBed, selectedBed.item);
    if (selectedBed) {
      tenant(selectedBed, selectedBed.item);
    }
  };

  const handleHoldUnholdBed = (bed) => {
    if (!bed?.id) return;

    const isOnHold = bed.status === Config.BED_STATUS.ON_HOLD;

    holdUnholdBedMutate({
      bedId: bed.id,
      status: isOnHold
        ? Config.BED_STATUS.VACANT
        : Config.BED_STATUS.ON_HOLD,
    });
  };

  useEffect(() => {
    if (apiData) {
      let filteredData = apiData;

      //For All show original data
      // if (selectedFilter === "ALL") {
      //   filteredData = filteredData.filter((room) => {
      //     if (Array.isArray(room.beds) && room.beds.length > 0) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   });
      // } else 
      if (selectedFilter === "VACANT") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.VACANT
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.VACANT
            ),
          }));
      } else if (selectedFilter === "OCCUPIED") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.OCCUPIED
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.OCCUPIED
            ),
          }));
      }
      else if (selectedFilter === "ON_HOLD") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.ON_HOLD
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.ON_HOLD
            ),
          }));
      }

      else if (selectedFilter === "MOVING_OUT") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.MOVING_OUT
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.MOVING_OUT
            ),
          }));
      }
      else if (selectedFilter === "DORMANT") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed?.isDormantInventory === 1
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed?.isDormantInventory === 1
            ),
          }));
      }
      else if (selectedFilter === "PENDING_DUES") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some((bed) => bed.isDuePending > 0);
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter((bed) => bed.isDuePending > 0),
          }));
      }

      const tempData = filteredData?.map((item) => ({
        flat: getFloor(item),
        name: getName(item),
        occupancyStatus: getOccupancyStatus(item.beds, item),
        rent: getAmount(item.beds),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, selectedFilter, isFlat]);
  useEffect(() => {
    if (!Array.isArray(apiData)) {
      onHoldBedCountChange?.(0);
      return;
    }

    const holdBedCount = apiData.reduce((total, room) => {
      if (!Array.isArray(room?.beds)) {
        return total;
      }

      return (
        total +
        room.beds.filter(
          (bed) => bed?.status === Config.BED_STATUS.ON_HOLD
        ).length
      );
    }, 0);

    onHoldBedCountChange?.(holdBedCount);
  }, [apiData, onHoldBedCountChange]);

  const getFloor = (item) => {
    return (
      <div className="flex items-center w-full">
        <div className="flex items-center min-w-0">
          {/* {isFlat &&
            <div
              className={`
            w-8 h-8 flex items-center justify-center rounded-full mr-3
            ${item.gender === 1
                  ? "bg-gray-100"
                  : item.gender === 2
                    ? "bg-gray-100"
                    : "bg-gray-100"
                }
          `}
            >
              {item.gender === 1 ? (
                <FaMale className="text-blue-600" />
              ) : item.gender === 2 ? (
                <FaFemale className="text-pink-600" />
              ) : (
                <BiMaleFemale className="text-purple-600" />
              )}
            </div>
          } */}
          <div className="flex flex-col min-w-0">
            <span className="font-medium text-gray-700">
              {isFlat
                ? `Flat ${item.flatName || item.name}`
                : `Floor ${item.floor}`}
            </span>

            {isFlat && (
              <span
                className={`
                text-xs font-medium
                ${item.gender === 1
                    ? "text-blue-600"
                    : item.gender === 2
                      ? "text-pink-600"
                      : "text-purple-600"
                  }
          `}
              >
                {item.gender === 1
                  ? "Male Only"
                  : item.gender === 2
                    ? "Female Only"
                    : "Co-Living"}
              </span>
            )}
          </div>
        </div>

        {isFlat && item.flatName && (
          <button
            onClick={() => editFlat(item)}
            className="
            flex items-center justify-center
            w-8 h-8
            rounded-full
            text-gray-500
            hover:bg-primary-color/10
            transition-all
          "
            title="Edit Flat"
          >
            <MdOutlineEdit size={14} />
          </button>
        )}
      </div>
    );
  };

  const getName = (item) => {
    const isDisabled = item.flatStatus === Config.FLAT_STATUS.INACTIVE;
    return (
      <div className="flex items-center text-sm text-gray-600">
        {item.roomNum ? (
          <>
            {item.roomNum}
            <button
              onClick={() => {
                if (!isDisabled) {
                  editRoom(item);
                }
              }}
              className={`flex items-center justify-center w-8 h-8 rounded-full cursor-pointer hover:bg-primary-color/10 transition-all ${isDisabled
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-500"
                }`}
              // className="flex items-center justify-center w-8 h-8 rounded-full text-gray-500
              // hover:bg-primary-color/10 transition-all"
              title={isDisabled ? "First activate the flat" : "Edit Room"}
            >
              <MdOutlineEdit size={14} />
            </button>
            {/* <MdOutlineEdit
              className={`text-[13px] ml-2 cursor-pointer ${isDisabled
                ? "text-gray-400 cursor-not-allowed"
                : "text-primary-color/70"
                }`}
              title={isDisabled ? "First activate the flat" : "Edit Room"}
              onClick={() => {
                if (!isDisabled) {
                  editRoom(item);
                }
              }}
            /> */}
          </>
        ) : (
          // <BsDash className="w-7 h-7" />
          <div className="flex items-center gap-2 text-sm text-gray-400 italic">
            <MdOutlineMeetingRoom className="text-gray-300" />
            No room added
          </div>
        )}
      </div>
    );
  };

  const getAmount = (beds) => {
    const firstBed = beds?.[0];

    return firstBed ? (
      <Amount className="flex items-center text-sm text-gray-600">
        {"₹" + firstBed.rent}
      </Amount>
    ) : (
      <BsDash className="w-7 h-7" />
    );
  };

  const getToolStatusText = (bed) => {
    if (bed.isDuePending > 0) {
      return (
        <span className="flex items-center gap-1 text-xs font-medium text-red-600">
          <span>Pending</span>
          <span className="text-red-700">
            ₹{bed.isDuePending.toLocaleString()}
          </span>
        </span>
      );
    }

    return (
      <span className="text-xs font-medium text-green-600">
        Paid
      </span>
    );
  };


  const BED_STATUS_NAMES = {
    [Config.ROOM_STATUS.INACTIVE]: "Inactive Room",
    [Config.BED_STATUS.VACANT]: "Vacant",
    [Config.BED_STATUS.VACANT_RESERVED]: "Vacant Reserved",
    [Config.BED_STATUS.OCCUPIED]: "Occupied",
    [Config.BED_STATUS.MOVING_OUT]: "Moving Out",
    [Config.BED_STATUS.RESERVED]: "Reserved",
    [Config.BED_STATUS.ON_HOLD]: "Onhold",
  };
  const getOccupancyStatus = (beds = [], item) => {

    const validBeds = Array.isArray(beds) ? beds : [];

    if (validBeds.length === 0) {
      return (
        <div className="flex items-center gap-2 text-sm text-gray-400 italic">
          <FaBed className="text-gray-300" />
          No beds added
        </div>
      );
    }

    return (
      <div className="flex flex-wrap items-center gap-2 max-w-md">
        {validBeds.map((bed) => {
          let bedColor = "";

          if (item.status === Config.ROOM_STATUS.INACTIVE) {
            bedColor = "text-gray-200";
          } else if (
            bed.status === Config.BED_STATUS.OCCUPIED &&
            item.isFlatFullyOccupied
          ) {
            bedColor = "text-yellow-400 cursor-pointer";
          } else if (
            bed.status === Config.BED_STATUS.OCCUPIED &&
            item.isFullyOccupied &&
            item.type !== Config.ROOM_TYPES.SINGLE_SHARING
          ) {
            bedColor = "text-violet-600 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.OCCUPIED) {
            bedColor = "text-green-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.VACANT) {
            bedColor = "text-gray-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.MOVING_OUT) {
            bedColor = "text-red-600 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.VACANT_RESERVED) {
            bedColor = "text-teal-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.RESERVED) {
            bedColor = "text-blue-500 cursor-pointer";
          }
          else if (bed.status === Config.BED_STATUS.ON_HOLD) {
            bedColor = "text-orange-500 cursor-pointer";
          }
          else {
            bedColor = "text-red-500 cursor-pointer";
          }

          let clickTimeout = null;
          let clickCount = 0;

          const handleClick = (e) => {
            e.stopPropagation();
            clickCount++;

            if (clickCount === 1) {
              clickTimeout = setTimeout(() => {
                if (item.status !== Config.ROOM_STATUS.INACTIVE) {
                  handleBedClick(bed, item);
                }
                clickCount = 0;
              }, 300);
            }
          };

          const handleDoubleClick = (e) => {
            e.stopPropagation();
            clearTimeout(clickTimeout);
            clickCount = 0;
            if (
              // (
              //   bed.status === Config.BED_STATUS.VACANT ||
              //   bed.status === Config.BED_STATUS.ON_HOLD
              // ) &&
              item.status !== Config.ROOM_STATUS.INACTIVE
            ) {
              handleBedDoubleClick(bed, item);
            }
          };

          const tooltipContentOld = (
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-4">
                <div className="flex items-center">
                  {propStatus === 2 || propStatus === 4 ? (
                    <span className="text-red-500 font-semibold text-base flex">
                      <IoMdHelpCircleOutline className="w-6 h-6 mr-2" />
                      Please activate the property first from the properties page to add the tenant.
                    </span>
                  ) : (
                    <>
                      {" "}
                      <TbRectangleVerticalFilled
                        className={`w-6 h-6 ${bedColor} mr-2`}
                      />
                      <span className="text-sm font-medium text-gray-800">
                        {item.status === Config.ROOM_STATUS.INACTIVE ? (
                          <span className="text-red-500 font-medium text-base flex">
                            Inactive Room. Please activate the room first to
                            add tenant.
                          </span>
                        ) : (
                          BED_STATUS_NAMES[bed.status] || "Unknown Status"
                        )}
                      </span>
                      {(bed.status === Config.BED_STATUS.VACANT) && (
                        <span className="text-xs text-gray-500 ml-2">
                          (Double click to delete)
                        </span>
                      )}
                      {bed.status === Config.BED_STATUS.ON_HOLD && (
                        <span className="text-xs text-orange-600 ml-2 font-medium">
                          (Double click to unhold or delete)
                        </span>
                      )}
                    </>
                  )}
                </div>
                {bed.isDuePending > 0 && (
                  <span className="text-sm font-semibold">
                    {getToolStatusText(bed)}
                  </span>
                )}
              </div>

              {/* Row 2: Tenant info */}
              {(bed.status === Config.BED_STATUS.OCCUPIED ||
                bed.status === Config.BED_STATUS.MOVING_OUT ||
                bed.status === Config.BED_STATUS.RESERVED) &&
                bed.occupancies?.length > 0 && (
                  // <div className="ml-8 mt-1 space-y-1 text-xs text-gray-600">
                  //   {bed.occupancies.map((occ, index) => (
                  //     <div key={occ.id || index} className="space-y-0.5">
                  //       <div className="font-medium text-gray-800">
                  //         {occ?.tenantName ? truncateText(occ?.tenantName, 20) : ''}
                  //         <span className="text-gray-500">
                  //           {occ?.status !== undefined &&
                  //             ' (' + (BED_STATUS_NAMES[occ.status] || 'Unknown') + ')'}
                  //         </span>
                  //       </div>

                  //       {occ?.tenantMobile && (
                  //         <div className="text-gray-500">
                  //           {'#' + occ.tenantMobile}
                  //         </div>
                  //       )}
                  //     </div>
                  //   ))}
                  // </div>
                  <div className="mt-2 space-y-2 border-t pt-2">
                    {bed.occupancies.map((occ, index) => (
                      <div
                        key={occ.id || index}
                        className="flex flex-col gap-0.5"
                      >
                        {/* Tenant name + status */}
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-gray-800">
                            {capitalizeFirstLetter(truncateText(occ?.tenantName || "—", 22))}
                          </span>

                          {occ?.status !== undefined && (
                            <span className="text-[11px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
                              {BED_STATUS_NAMES[occ.status] || "Unknown"}
                            </span>
                          )}
                        </div>

                        {/* Contact (secondary) */}
                        {occ?.tenantMobile && (
                          <span className="text-xs text-gray-500">
                            {occ.tenantMobile}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>

                )}
            </div>
          );

          /* ---------- HELPERS ---------- */

          const getInitials = (name = "") =>
            name
              .split(" ")
              .slice(0, 2)
              .map(n => n[0])
              .join("")
              .toUpperCase();

          const getGenderIcon = (gender) => {
            if (gender === 1) return "♂";
            if (gender === 2) return "♀";
            return null;
          };

          const getStatusLabel = (status) =>
            BED_STATUS_NAMES[status] || "Unknown";

          /* ---------- TOOLTIP CONTENT ---------- */

          const tooltipContent = (
            <div className="w-72 rounded-lg bg-white p-3">
              {/* HEADER */}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <TbRectangleVerticalFilled className={`w-5 h-5 ${bedColor}`} />
                  <span className="text-sm font-semibold text-gray-800">
                    {getStatusLabel(bed.status)}
                  </span>
                </div>

                {/* {bed.isDuePending > 0 && (
                  <span className="text-sm font-semibold text-red-600">
                    Pending ₹{bed.isDuePending}
                  </span>
                )} */}
                {bed.status === Config.BED_STATUS.VACANT ? (
                  <span className="text-sm font-semibold text-gray-800">
                    Rent ₹{Number(bed?.rent || 0).toLocaleString("en-IN")}
                  </span>
                ) : Number(bed.isDuePending) > 0 ? (
                  <span className="text-sm font-semibold text-red-600">
                    Pending ₹{Number(bed?.isDuePending).toLocaleString("en-IN")}
                  </span>
                ) : null}
              </div>

              {/* WARNING */}
              {(propStatus === 2 || propStatus === 4) && (
                <div className="mt-2 flex gap-2 text-red-600 text-xs">
                  <IoMdHelpCircleOutline className="w-4 h-4 shrink-0 mt-0.5" />
                  <span>
                    Please activate the property first to add a tenant.
                  </span>
                </div>
              )}

              {/* TENANT LIST */}
              {(bed.status === Config.BED_STATUS.OCCUPIED ||
                bed.status === Config.BED_STATUS.MOVING_OUT ||
                bed.status === Config.BED_STATUS.RESERVED || bed.status === Config.BED_STATUS.VACANT_RESERVED) &&
                bed.occupancies?.length > 0 && (
                  <>
                    <div className="my-2 border-t border-gray-200" />

                    <div className="space-y-2">
                      {bed.occupancies.map((occ, index) => (
                        <div
                          key={occ.id || index}
                          className="flex items-start gap-2 rounded-md px-2 py-2 hover:bg-gray-50 cursor-pointer"
                          onClick={() => goToTenantDetails(occ.tenantId)}
                        >
                          {/* AVATAR */}
                          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-semibold text-gray-700">
                            {getGenderIcon(occ.tenantGender) ||
                              getInitials(occ.tenantName)}
                          </div>

                          {/* INFO */}
                          <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-medium text-gray-800">
                                {capitalizeFirstLetter(
                                  truncateText(occ?.tenantName || "—", 18)
                                )}
                              </span>

                              {occ?.status !== undefined && (
                                <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                                  {getStatusLabel(occ.status)}
                                </span>
                              )}
                            </div>

                            {occ?.tenantMobile && (
                              <span className="text-xs text-gray-500">
                                {occ.tenantMobile}
                              </span>
                            )}

                            {/* MOVE IN / MOVE OUT DATES */}
                            {(occ?.moveInDate || occ?.moveOutDate) && (
                              <div className="flex gap-3 mt-1 text-[11px] text-gray-500">
                                {occ?.moveInDate && (
                                  <span>
                                    Move-in: {moment(occ.moveInDate).format("DD MMM, YY")}
                                  </span>
                                )}
                                {occ?.moveOutDate && (
                                  <span className="text-orange-600 font-medium">
                                    Move-out: {moment(occ.moveOutDate).format("DD MMM, YY")}
                                  </span>
                                )}
                              </div>
                            )}

                            {/* Rent */}
                            {(occ?.rent) && (
                              <div className="flex gap-3 text-[11px] text-gray-500">
                                <span>
                                  Rent: {'₹' + occ?.rent}
                                </span>
                              </div>
                            )}

                            {/* Security */}
                            {(occ?.rent) && (
                              <div className="flex gap-3 text-[11px] text-gray-500">
                                <span>
                                  Security: {'₹' + occ?.security}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* CTA */}
                          {/* <span className="ml-auto text-xs text-blue-600 font-medium">
                            View tenant
                          </span> */}
                        </div>
                      ))}
                    </div>
                  </>
                )}

              {/* VACANT BED CTA */}
              {bed.status === Config.BED_STATUS.VACANT && (
                <>
                  <div className="my-2 border-t border-gray-200" />

                  <div
                    className="px-2 py-2 rounded-md hover:bg-blue-50 cursor-pointer"
                    onClick={handleAddNewTenant}
                  >
                    <span className="text-sm font-medium text-primary-color">
                      + Click to add tenant
                    </span>
                  </div>

                  <div className="mt-1 text-xs text-gray-400">
                    Double click to hold or delete bed
                  </div>
                </>
              )}

              {/* ON HOLD WARNING */}
              {bed.status === Config.BED_STATUS.ON_HOLD && (
                <div className="mt-3 rounded-md bg-orange-50 border border-orange-200 px-3 py-2">
                  <div className="flex items-start gap-2">
                    <IoMdHelpCircleOutline className="w-4 h-4 text-orange-600 shrink-0 mt-0.5" />

                    <div className="flex flex-col gap-0.5">
                      <span className="text-xs font-semibold text-orange-700">
                        Bed is on hold
                      </span>

                      <span className="text-xs text-orange-600">
                        You cannot add a tenant to a held bed.
                      </span>

                      <span className="text-[11px] text-orange-500 mt-1">
                        Double click to unhold or delete this bed.
                      </span>
                    </div>
                  </div>
                </div>
              )}

            </div>
          );



          return (
            <CustomTooltip
              key={`tooltip-${item.id}-${bed.id}`}
              content={tooltipContent}
              id={`tooltip-occupancyStatus-${item.id}-${bed.id}`}
            >
              <div
                key={`bed- ${bed.id}`}
                className="relative"
                onClick={handleClick}
                onDoubleClick={handleDoubleClick}
              >
                {bed.isDuePending > 0 && (
                  <FaRupeeSign className="absolute top-3 left-1/2 transform -translate-x-1/2 text-white w-4 h-4 cursor-pointer" />
                )}
                <TbRectangleVerticalFilled className={`${bedColor} w-10 h-10`} />
              </div>
            </CustomTooltip>
          );
        })}
        {beds.length > 0 &&
          <span className="text-xs text-gray-400 ml-2">
            {beds.length} beds
          </span>
        }
      </div>
    );
  };

  const ActionBtns = (item) => {
    const hasBeds = item.beds && item.beds.length > 0;
    const allBedsVacant = hasBeds && item.beds.every((bed) => bed.status === 1);
    const disableButton =
      (hasBeds && !allBedsVacant) ||
      item.status === Config.ROOM_STATUS.INACTIVE || selectedFilter === "VACANT";

    return (
      <div className="flex justify-center gap-3 w-full">
        {item.roomNum ? (
          <button
            title={disableButton ? "Beds already occupied" : "Add Bed"}
            onClick={() => {
              if (!disableButton) {
                bed(item);
              }
            }}
            className={`
            flex items-center gap-2
            px-4 py-2
            text-sm font-medium
            rounded-lg
            transition-all duration-150 ease-out
            active:scale-[0.98]
            
            ${disableButton
                ? "bg-gray-50 text-gray-400 border border-gray-200 cursor-not-allowed shadow-none"
                : "bg-white text-gray-700 border border-gray-200 shadow-sm hover:bg-gray-50 hover:shadow-md"
              }
            `}
            disabled={disableButton}
          >
            <span
              className={`
                w-5 h-5 flex items-center justify-center rounded-full
                ${disableButton ? "bg-gray-100" : "bg-gray-100"}
              `}
            >
              <MdAdd className={`${disableButton ? "text-gray-400" : "text-gray-600"} text-sm`} />
            </span>
            Add Bed
          </button>
        ) : (
          <button onClick={() => addRoomNumber(item)} className="
            flex items-center gap-1
            px-4 py-2
            text-sm font-medium
            rounded-lg  
            border border-gray-200
            bg-white
            text-gray-700
            shadow-sm
            hover:bg-gray-50
            hover:shadow-md
            transition-all duration-150 ease-out
            active:scale-[0.98]
          ">
            <span
              className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-100"
            >
              <MdAdd className="text-gray-600 text-sm" />
            </span>
            Add Room
          </button>
        )
        }
      </div >
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Flat/Floor",
          accessor: "flat",
        },
        {
          Header: "Room Name",
          accessor: "name",
        },
      ];
    }

    const bedStatusTooltipContent = (
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-green-400 w-6 h-6" />
          <span>Occupied</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-gray-400 w-6 h-6" />
          <span>Vacant</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-red-600 w-6 h-6" />
          <span>Moving Out</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-teal-400 w-6 h-6" />
          <span>Vacant Reserved</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-blue-500 w-6 h-6" />
          <span>Reserved</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-yellow-400 w-6 h-6" />
          <span>Fully Occupied (Flat)</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-violet-600 w-6 h-6" />
          <span>Fully Occupied (Room)</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-gray-200 w-6 h-6" />
          <span>Inactive</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-orange-500 w-6 h-6" />
          <span>Hold Bed</span>
        </div>
        <div className="flex items-center gap-2">
          <FaCircle className="text-gray-400 w-6 h-6" />
          <span>Extra Bed</span>
        </div>
      </div>
    );

    return [
      {
        Header: "Flat/Floor",
        accessor: "flat",
      },
      {
        Header: "Room Name",
        accessor: "name",
      },
      {
        Header: () => (
          <div className="flex items-center">
            Beds
            <CustomTooltip
              content={bedStatusTooltipContent}
              id="bed-status-info"
              position="top"
            >
              <FaInfoCircle className="ml-2 text-gray-500 cursor-pointer" />
            </CustomTooltip>
          </div>
        ),
        accessor: "occupancyStatus",
      },
      // {
      //   Header: "Rent per bed",
      //   accessor: "rent",
      // },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  const goToTenantDetails = (bedId, tenantId) => {
    setIsModalOpen(false);
    // navigate(`/tenantdetails/b/${tenantId}`, {
    //   state: { tenantStatus: Config.TENANT_STATUS.RESERVED },
    // });
    openTenantDetailsModal(tenantId);
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case Config.BED_STATUS.MOVING_OUT:
        return "Moving Out";
      case Config.BED_STATUS.RESERVED || Config.BED_STATUS.VACANT_RESERVED:
        return "Reserved";
      case Config.BED_STATUS.ON_HOLD:
        return "Onhold";
      default:
        return "Active";
    }
  };


  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Bed Status:</strong>{" "}
                          {data[rowIndex].occupancyStatus}
                        </li>

                        <li className="flex gap-2">
                          <strong>Rent/Bed:</strong> {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {isModalOpen && (
        <Model
          setOpenModel={setIsModalOpen}
          width="w-full max-w-sm"
          title="Bed Occupancy Details"
        >
          {selectedBed?.occupancies?.map((occ, index) => (
            <div key={occ.tenantId}>
              <button
                className="w-full text-left px-4 py-3 hover:bg-gray-100 flex justify-between items-center"
                onClick={() => goToTenantDetails(selectedBed.id, occ.tenantId)}
              >
                <div className="flex flex-col w-full">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-900 font-medium">
                      {occ.tenantName || `Tenant ${index + 1}`}
                    </span>

                    <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                      {getStatusLabel(occ.status)}
                    </span>
                  </div>

                  {/* <span className="text-sm text-gray-500">
                    {occ.tenantMobile}
                  </span> */}

                  {/* MOVE IN / MOVE OUT DATES */}
                  {(occ?.moveInDate || occ?.moveOutDate) && (
                    <div className="flex gap-3 mt-0.5 text-[11px] text-gray-500">
                      {occ?.moveInDate && (
                        <span>
                          In: {moment(occ.moveInDate).format("DD MMM, YY")}
                        </span>
                      )}

                      {occ?.moveOutDate && (
                        <span className="text-orange-600 font-medium">
                          Out: {moment(occ.moveOutDate).format("DD MMM, YY")}
                        </span>
                      )}
                    </div>
                  )}

                  <span className="text-xs text-gray-500">
                    Room {selectedBed.roomNum}
                  </span>
                </div>

                <span className="text-gray-400 text-lg ml-2">→</span>
              </button>

              {index !== selectedBed.occupancies.length - 1 && (
                <div className="border-t border-gray-200 mx-4" />
              )}
            </div>
          ))}

          {selectedBed?.canAddTenant === true && (
            <>
              <div className="border-t border-gray-300" />
              <button
                className="w-full text-left px-4 py-3 text-primary-color font-medium hover:bg-primary-color/50"
                onClick={handleAddNewTenant}
              >
                + Add New Tenant
              </button>
            </>
          )}
        </Model>
      )}

      {isBedActionModalOpen && (
        <Model
          setOpenModel={setIsBedActionModalOpen}
          width="w-full max-w-sm"
          title="Bed Actions"
        >
          <div className="flex flex-col">
            {/* Hold / Unhold Bed */}
            {(selectedBed?.status === Config.BED_STATUS.VACANT ||
              selectedBed?.status === Config.BED_STATUS.ON_HOLD) && (
                <><button
                  className="w-full text-left px-4 py-4 hover:bg-gray-100 flex items-center gap-3"
                  disabled={holdUnholdBedLoading}
                  onClick={() => {
                    setIsBedActionModalOpen(false);
                    handleHoldUnholdBed(selectedBed);
                  }}
                >
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${selectedBed?.status === Config.BED_STATUS.ON_HOLD
                      ? "bg-green-100"
                      : "bg-orange-100"}`}
                  >
                    <span
                      className={`text-lg ${selectedBed?.status === Config.BED_STATUS.ON_HOLD
                        ? "text-green-600"
                        : "text-orange-600"}`}
                    >
                      {selectedBed?.status === Config.BED_STATUS.ON_HOLD ? "▶" : "⏸"}
                    </span>
                  </div>

                  <div className="flex flex-col">
                    <span
                      className={`font-medium ${selectedBed?.status === Config.BED_STATUS.ON_HOLD
                        ? "text-green-600"
                        : "text-gray-900"}`}
                    >
                      {selectedBed?.status === Config.BED_STATUS.ON_HOLD ? "Release Bed" : "Hold Bed"}
                    </span>

                    <span className="text-xs text-gray-500">
                      {selectedBed?.status === Config.BED_STATUS.ON_HOLD
                        ? "Make this bed available again"
                        : "Temporarily reserve this bed"}
                    </span>
                  </div>

                  <span className="ml-auto text-gray-400 text-lg">
                    →
                  </span>
                </button><div className="border-t border-gray-200 mx-4" /></>
              )}
            {/* Bed History */}
            <button
              className="w-full text-left px-4 py-4 hover:bg-gray-100 flex items-center gap-3"
              onClick={() => {
                setIsBedActionModalOpen(false);
                handleBedHistory(selectedBed);
              }}
            >
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                <span className="text-blue-600 text-lg">🕘</span>
              </div>

              <div className="flex flex-col">
                <span className="text-gray-900 font-medium">Bed History</span>

                <span className="text-xs text-gray-500">
                  View past tenant allocations history
                </span>
              </div>

              <span className="ml-auto text-gray-400 text-lg">→</span>
            </button>
            {(selectedBed?.status === Config.BED_STATUS.VACANT) && (
              <>
                <div className="border-t border-gray-200 mx-4" />
                {/* Delete Bed */}
                <button
                  className="w-full text-left px-4 py-4 hover:bg-red-50 flex items-center gap-3"
                  onClick={() => {
                    setIsBedActionModalOpen(false);
                    handleDeleteBed(selectedBed);
                  }}
                >
                  <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                    <span className="text-red-600 text-lg">
                      🗑
                    </span>
                  </div>

                  <div className="flex flex-col">
                    <span className="text-red-600 font-medium">
                      Delete Bed
                    </span>

                    <span className="text-xs text-gray-500">
                      Permanently remove this bed
                    </span>
                  </div>

                  <span className="ml-auto text-gray-400 text-lg">
                    →
                  </span>
                </button>
              </>)}
          </div>
        </Model>
      )}

      {apiData?.length > 0 && (
        <PaginationWrapper className='pb-6'>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
//const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Thead = tw.thead`
  border-b bg-gray-50
`;

const Tbody = tw.tbody`${(props) =>
  props.hasdata === "true" ? "border-b" : ""}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50 `;
//const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Th = tw.th`
  text-left text-xs md:text-sm
  font-medium text-gray-500
  px-3 py-2
`;

const Td = tw.td`p-1 text-sm md:p-3 text-left`;
const Amount = tw.p`text-gray-700 text-sm font-medium flex`;
export default Table;